import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

import { Page } from '@occc-app/design-system';
import { RetailerNetworkLocationDataFragment } from '@occc/graphql';

import {
  RetailerNetworkLocationUpdateFormValues,
  RetailerNetworkLocationUpdateFormInitialValues,
} from './retailer-network-location-update-page.types';
import { RetailerNetworkLocationUpdateForm } from './retailer-network-location-update-form.component';
import { validateRetailerNetworkLocationUpdateForm } from './retailer-network-location-update-page.validation';
import { PAGE_TITLE } from './retailer-network-location-update-page.constants';

type RetailerNetworkLocationUpdatePageProps = {
  location: RetailerNetworkLocationDataFragment;
  initialValues: RetailerNetworkLocationUpdateFormInitialValues;
  onSubmit: (values: RetailerNetworkLocationUpdateFormValues) => void;
  goBack: () => void;
};

export const RetailerNetworkLocationUpdatePage = ({
  location,
  initialValues,
  onSubmit,
  goBack,
}: RetailerNetworkLocationUpdatePageProps) => {
  const locationName = location.siteSystemConfiguration?.[0]?.identifier;

  return (
    <Page
      browserTabTitle={locationName || PAGE_TITLE}
      pageHeaderProps={{ title: locationName || '' }}
      containerProps={{ variant: 'md' }}
    >
      <Form<RetailerNetworkLocationUpdateFormValues, RetailerNetworkLocationUpdateFormInitialValues>
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ values, handleSubmit, submitting, pristine }) => {
          return (
            <RetailerNetworkLocationUpdateForm
              details={values.details}
              geoLocation={values.geoLocation}
              hasAddress={!!location.address}
              handleSubmit={handleSubmit}
              disableSubmit={pristine || submitting}
              goBack={goBack}
            />
          );
        }}
        mutators={{ ...arrayMutators }}
        validate={validateRetailerNetworkLocationUpdateForm}
      />
    </Page>
  );
};
